import { config, useSpring } from '@react-spring/web';
import { useResponsiveBreakPoints } from '@restworld/utils-common';
import { useEffect, useState } from 'react';

export function useMobileNavbarCrossingAnimation() {
  const [scrollY, setScrollY] = useState<number>(0);
  const { isDesktop } = useResponsiveBreakPoints();
  const scrollMark = 10;

  const navbarAnimation = useSpring({
    config: config.wobbly,
  });

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return { navbarAnimation, hasCrossedNavbar: scrollY > scrollMark && !isDesktop };
}
